import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins, fontSize } from '../styles';
import { Container, Heading, Link } from './ui';
import eyeIcon from '../images/eye-icon.bg.svg';

const StyledOtherSpaLocations = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledItems = styled.ul`
  column-count: 2;
  column-gap: 20px;

  ${minBreakpointQuery.tsmall`
    column-count: 3;
  `}

  ${minBreakpointQuery.smedium`
    column-count: 4;
  `}
`;

const StyledItem = styled.li`
  margin-bottom: 8px;
  padding-left: 26px;
  background: url(${eyeIcon}) no-repeat 0 4px / 16px 12px;

  ${minBreakpointQuery.small`
    margin-bottom: 10px;
    background-position-y: 6px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 12px;
    background-position-y: 8px;
  `}
`;

const StyledLink = styled(Link)`
  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}
`;

const OtherSpaLocations = ({ location, items }) =>
  items &&
  items.length > 0 && (
    <StyledOtherSpaLocations>
      <Container>
        <StyledHeading>{`Other spa locations${
          location ? ` ${(location.type === "CITY" || location.type === "TOWN" || location.type === "OTHER" ? 'near' : 'in')} ${location.name}` : ''
        }`}</StyledHeading>
        <StyledItems>
          {items.map(({ name, url }, id) => (
            <StyledItem key={id}>
              <StyledLink to={url}>{name}</StyledLink>
            </StyledItem>
          ))}
        </StyledItems>
      </Container>
    </StyledOtherSpaLocations>
  );

export default OtherSpaLocations;

export const OtherSpaLocationsFragment = graphql`
  fragment OtherSpaLocationsFragment on SPASEEKERS_LocationUrl {
    name
    url
  }
`;
